import { SmilePlusSubscriptionPlanProductEnum } from "types/User";

class Item<T> {
  constructor(private readonly key: string, private readonly defaultValue: T) {}

  get(): T {
    return this.getOr(this.defaultValue);
  }

  getOr(value: T): T {
    if (!process.browser) {
      return this.defaultValue;
    }
    try {
      return JSON.parse(localStorage.getItem(this.key) as string) ?? value;
    } catch (_) {
      return this.defaultValue;
    }
  }

  set(value: T): void {
    if (!process.browser) {
      return;
    }
    localStorage.setItem(this.key, JSON.stringify(value));
  }

  remove(): void {
    if (!process.browser) {
      return;
    }
    localStorage.removeItem(this.key);
  }

  pull(): T {
    const value = this.get();
    this.remove();
    return value;
  }
}

export const Storage = {
  smileSelectedPlan: new Item("smile.selectedPlan", SmilePlusSubscriptionPlanProductEnum.NONE),
  smileForgotPasswordDefaultEmail: new Item("smile.forgotPassword.defaultEmail", ""),
};
